import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  LeavePolicy,
  LeavePolicyApi,
} from 'src/app/shared/models/leave/leave-policy.interface';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import {
  ApiLeaveBal,
  LeaveBal,
} from 'src/app/shared/models/leave/leave-bal.interface';
import {
  AllLeaveCardApi,
  LeaveCard,
  LeaveCardApi,
} from 'src/app/shared/models/leave/leave.interface';
export interface Api {
  msg: string;
  status: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class LeaveService {
  constructor(private http: HttpClient) {}

  leavePlicyReport(): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/leaves/get_report_fro_leave_policy`
    );
  }
  withdrawRegulariseRqst(req): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/payroll/attendance/withdrawRegulariseRqst`,
      req
    );
  }

  leavevpolicyGet(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(`${environment.apiUrl}/leaves/get_lv_plcy_type`, {
      params: param,
    });
  }

  editpolicyStatus(stat, plcyID): Observable<any> {
    const option = {
      status: stat,
      plcy_type_id: plcyID,
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(
      `${environment.apiUrl}/leaves/edit_lv_type_status_action`,
      options
    );
  }

  editPolicy(plcyID): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/leaves/edit_lv_plcy_type/` + plcyID
    );
  }

  deletePolicy(plcyID): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/leaves/delete_leave_plcy_type`,
      { plcy_type_id: plcyID }
    );
  }

  addPolicy(data: FormData, plcyID): Observable<any> {
    if (!plcyID) {
      return this.http.post<any>(
        `${environment.apiUrl}/leaves/add_lv_plcy_type_action`,
        data
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/leaves/edit_lv_plcy_type_action`,
        data
      );
    }
  }

  leaveTypeGet(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/leaves/get_lv_types`);
  }
  downloadExcelLeaveType(): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/leaves/get_Excel_lv_types`
    );
  }

  editLeaveTypeStatus(stat, lvtypID): Observable<any> {
    const option = {
      status: stat,
      lv_type_id: lvtypID,
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(
      `${environment.apiUrl}/leaves/edit_leave_types_status_action`,
      options
    );
  }

  editLeaveType(lvtypID): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/leaves/edit_leave_types/` + lvtypID
    );
  }

  deleteLeaveType(lvtypID): Observable<any> {
    return this.http.post(`${environment.apiUrl}/leaves/delete_leave_type`, {
      lv_type_id: lvtypID,
    });
  }

  addLeaveType(data: FormData, lvtypID): Observable<any> {
    if (!lvtypID) {
      return this.http.post<any>(
        `${environment.apiUrl}/leaves/add_lv_types_action`,
        data
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/leaves/edit_leave_types_action`,
        data
      );
    }
  }

  getEmpLeaveBal(data: any): Observable<any> {
    const option = {
      params: {
        self: '',
        emp_id: '',
        policy_type_id: '',
        leave_type_id: '',
        costCenters: '',
        is_excel: '',
        page: '',
        limit: '',
      },
    };
    if (data.self !== '' && data.self !== undefined) {
      option.params.self = data.self;
    }
    if (data.emp_id !== '' && data.emp_id !== undefined) {
      option.params.emp_id = data.emp_id;
    }
    if (data.policy_type_id !== '' && data.policy_type_id !== undefined) {
      option.params.policy_type_id = data.policy_type_id;
    }

    if (data.leave_type_id !== '' && data.leave_type_id !== undefined) {
      option.params.leave_type_id = data.leave_type_id;
    }

    if (data.srch_costcenter !== '' && data.srch_costcenter !== undefined) {
      option.params.costCenters = data.srch_costcenter;
    }
    if (data.page !== '' && data.page !== undefined) {
      option.params.page = data.page;
    }
    if (data.limit !== '' && data.limit !== undefined) {
      option.params.limit = data.limit;
    }
    if (
      data.is_excel !== '' &&
      data.is_excel !== undefined &&
      data.is_excel === 1
    ) {
      option.params.is_excel = '1';
      return this.http.get<any>(
        `${environment.apiUrl}/leaves/employee_leave_bal`,
        option
      );
    }
    option.params.is_excel = '0';
    return this.http
      .get<any>(`${environment.apiUrl}/leaves/employee_leave_bal`, option)
      .pipe(map((x) => x.data));
  }
  // leave policy
  getPolicyMaster(data): Observable<LeavePolicy[]> {
    return this.http
      .get<LeavePolicyApi>(
        `${environment.apiUrl}/leaves/leave_policy?leave=${data.leave}&state_id=${data.state_id}&plcy_type_id=${data.plcy_type_id}&job_cat=${data.job_cat}`
      )
      .pipe(map((x) => x.data));
  }

  addLeavePolicy(data: FormData, plcyId): Observable<any> {
    if (!plcyId) {
      return this.http.post<any>(
        `${environment.apiUrl}/leaves/add_leave_policy_action`,
        data
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/leaves/edit_leave_policy_action`,
        data
      );
    }
  }

  editLeavePolicy(plcyID): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/leaves/edit_leave_policy/` + plcyID
    );
  }

  deleteLeavePolicy(plcyID): Observable<any> {
    return this.http.post(`${environment.apiUrl}/leaves/delete_leave_policy`, {
      plcy_id: plcyID,
    });
  }

  editLeavePolicyStatus(stat, plcyID): Observable<any> {
    const option = {
      status: stat,
      plcy_id: plcyID,
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(
      `${environment.apiUrl}/leaves/edit_leave_policy_status_action`,
      options
    );
  }

  EmpLeaveCard(data): Observable<LeaveCardApi> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    // for (const key in data.forms) {
    //   if (data.forms[key] !== '' && data.forms[key] !== undefined && data.forms[key] !== null) {
    //     param = param.append(key, data.forms[key]);
    //   }
    // }
    return this.http.get<LeaveCardApi>(
      `${environment.apiUrl}/leaves/leaveTypeAvgBal`,
      { params: param }
    );
  }

  EmpAllLeaveCard(data): Observable<AllLeaveCardApi> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<AllLeaveCardApi>(
      `${environment.apiUrl}/leaves/empLeaveCount`,
      { params: param }
    );
  }

  EmpLeaveRegister(data): Observable<any> {
    console.log(data);
    let param = new HttpParams();
    for (const key in data.forms) {
      if (
        data.forms[key] !== '' &&
        data.forms[key] !== undefined &&
        data.forms[key] !== null
      ) {
        param = param.append(key, data.forms[key]);
      }
    }

    if (
      'pageIndex' in data &&
      data.pageIndex !== '' &&
      data.pageIndex !== undefined
    ) {
      param = param.append('page', data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined) {
      param = param.append('limit', data.limit);
    }

    return this.http.get(`${environment.apiUrl}/leaves/leaveRegister`, {
      params: param,
    });
  }

  EmpLeaveRegisterAll(data): Observable<any> {
    console.log(data);
    let param = new HttpParams();
    for (const key in data.forms) {
      if (
        data.forms[key] !== '' &&
        data.forms[key] !== undefined &&
        data.forms[key] !== null
      ) {
        param = param.append(key, data.forms[key]);
      }
    }

    if (
      'pageIndex' in data &&
      data.pageIndex !== '' &&
      data.pageIndex !== undefined
    ) {
      param = param.append('page', data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined) {
      param = param.append('limit', data.limit);
    }

    return this.http.get(`${environment.apiUrl}/leaves/leaveRegisterAll`, {
      params: param,
    });
  }

  approveLeave(data): Observable<Api> {
    return this.http.post<Api>(
      `${environment.apiUrl}/leaves/ApproveLeave`,
      data
    );
  }

  builkApproveLeave(data): Observable<Api> {
    const reqData = data.map((res) => {
      return {
        lv_id: res.lv_id,
        lv_type: res.lv_type,
        emp_id: res.emp_id,
      };
    });
    // `${environment.apiUrl}/leaves/bulkApproveLeave`,
    return this.http.post<Api>(
      `${environment.apiUrl}/leaves/bulkApproveLeaveCron`,
      { leaves: reqData }
    );
  }

  rejectLeave(data): Observable<Api> {
    return this.http.post<Api>(
      `${environment.apiUrl}/leaves/PendingRejectLeave`,
      data
    );
  }

  // applierLeaveReject(data): Observable<Api> {
  //   return this.http.post<Api>(`${environment.apiUrl}/leaves/applierLeaveReject`, data);
  // }

  // Holiday Calendar

  getHoliday(data): Observable<any> {
    return this.http.get<LeavePolicyApi>(
      `${environment.apiUrl}/setups/holiday/get_holiday?page=${data.page}&limit=${data.limit}`
    );
  }

  addHoliday(data): Observable<any> {
    if (!data.hldy_id) {
      return this.http.post<any>(
        `${environment.apiUrl}/setups/holiday/add_holiday_action`,
        data
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/setups/holiday/edit_holiday_action`,
        data
      );
    }
  }

  editHoliday(hldyID): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/setups/holiday/edit_holiday/` + hldyID
    );
  }

  deleteHoliday(hldyID): Observable<any> {
    return this.http.delete(
      `${environment.apiUrl}/setups/holiday/delete_holiday/` + hldyID
    );
  }

  editHolidayStatus(stat, hldyID): Observable<any> {
    const option = {
      status: stat,
      hldy_id: hldyID,
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(
      `${environment.apiUrl}/setups/holiday/edit_holiday_status_action`,
      options
    );
  }

  // holiday region wise mapping

  holidayList(): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/setups/holiday/holiday_dropdown`
    );
  }

  mappedHolidays(data): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/setups/holiday/get_hldy_mapped?page=${data.page}&limit=${data.limit}`
    );
  }

  editmappedHoliday(ID): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/setups/holiday/edit_hldy_map/${ID}`
    );
  }

  deleteHolidayMapping(ID): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/setups/holiday/delete_hldy_map`,
      { hldy_id: ID }
    );
  }

  editmapHolidayStatus(stat, ID): Observable<any> {
    const option = {
      status: stat,
      hldy_id: ID,
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(
      `${environment.apiUrl}/setups/holiday/edit_hldy_status_action`,
      options
    );
  }

  // holiday region mapping
  addHolidayMapping(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/setups/holiday/holiday_map_action`,
      data
    );
  }

  isHldyMandatory(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/setups/holiday/is_mandatory_save_action`,
      data
    );
  }

  LeaveBalMaster(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(`${environment.apiUrl}/leaves/LeaveBalMaster`, {
      params: param,
    });
  }

  getAttendance(data): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/payroll/attendance/get_emp_attendance_by_month`,
      data
    );
  }
  initiateRegularise(data): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/payroll/attendance/initiate_regularise`,
      data
    );
  }
  getRegulariseHistory(data): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/payroll/attendance/regularise_history`,
      data
    );
  }
  getRegulariseAttCode(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/get_regularise_att_codes`);
  }
  getMyReporties(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_my_reporties_leave`);
  }

  // leave policy get
  getLeavepolicy(stID): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/leaves/get_leave_policy?st_id=${stID}`
    );
  }

  // long leave

  addLongLeave(data): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/employee/add_emp_long_lv_action`,
      data
    );
  }

  revokeLeave(data): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/employee/update_emp_long_leave_revoke`,
      data
    );
  }

  longLeaveEmp(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/employee/get_emp_long_leave`,
      { params: param }
    );
  }

  specificLeaveDetails(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/leaves/specificLeaveDetails`,
      { params: param }
    );
  }

  updateOpenBal(data): Observable<any> {
    return this.http.post(`${environment.apiUrl}/leaves/updateOpenBal`, data);
  }

  openBalModify(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/leaves/checkOBModifyRights`);
  }

  leaveReportiesExcel(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }

    return this.http.get(
      `${environment.apiUrl}/leaves/reportiesLeaveMasterExcel`,
      { params: param }
    );
  }

  regionWiseLeavePolicy(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/leaves/region_wise_lv_policy`,
      { params: param }
    );
  }
  downloadAttendance(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/leaves/download_attendance`,
      { params: param }
    );
  }

  uncoveredPcLvPolicy(): Observable<any> {
    return this.http.get(
      `${environment.apiUrl}/leaves/uncovered_leave_policy_pc`
    );
  }

  checkLeaveRulesLimit(data: FormData): Observable<any> {
    // let param = new HttpParams();
    // for (const key in data) {
    //   if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
    //     param = param.append(key, data[key]);
    //   }
    // }
    return this.http.post(
      `${environment.apiUrl}/leaves/check_lv_rules_limit`,
      data
    );
  }

  checkLeaveRules(data: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}/leaves/check_lv_rules`, data);
  }
  downloadRuleLeaveType(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/leaves/download_lv_rule_type`);
  }

  uploadLvRule(data): Observable<any> {
    return this.http.post(`${environment.apiUrl}/leaves/upload_lv_rule`, data);
  }

  getLeaveRule(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(`${environment.apiUrl}/leaves/get_lv_rule`, {
      params: param,
    });
  }

  getLeaveRuleType(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(`${environment.apiUrl}/leaves/get_lv_rule_type`, {
      params: param,
    });
  }

  downloadRuleLeaveRule(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/leaves/get_lv_rule_excel`);
  }

  myRuleLeaveRule(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/leaves/my_lv_rule`);
  }

  editLeaveRuleStatus(stat, lv_rule_id): Observable<any> {
    const option = {
      status: stat,
      lv_rule_id: lv_rule_id,
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(
      `${environment.apiUrl}/leaves/edit_leave_rule_status_action`,
      options
    );
  }

  addLeaveRule(data): Observable<any> {
    return this.http.post(`${environment.apiUrl}/leaves/addLeaveRule`, data);
  }
  getLeaves(mainLeaves, id): any {
    let data = [];
    data = mainLeaves.filter((x) => x.lv_type === id);
    if (data.length > 0) {
      return (data = data[0]); //.fixed(2);
    } else {
      return { available: 0, booked: 0 };
    }
  }

  currentLeaveCard(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    // for (const key in data.forms) {
    //   if (data.forms[key] !== '' && data.forms[key] !== undefined && data.forms[key] !== null) {
    //     param = param.append(key, data.forms[key]);
    //   }
    // }
    return this.http.get<any>(
      `${environment.apiUrl}/leaves/currentEmpLeaveCount`,
      { params: param }
    );
  }
  getLeavesFiles(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/leaves/getLeave_files`);
  }

  attendanceCalendar(req): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/payroll/attendance/attendanceCalendar`,
      req
    );
  }

  downloadAllUserAttendance(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/leaves/download_all_user_attendance`,
      { params: param }
    );
  }

  downloadUserLogAttendance(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/leaves/download_user_log_attendance`,
      { params: param }
    );
  }

  
  LeaveRelStgy(data:any): Observable<any> {
    let param = new HttpParams();
    for (const key in data.forms) {
      if (
        data.forms[key] !== '' &&
        data.forms[key] !== undefined &&
        data.forms[key] !== null
      ) {
        param = param.append(key, data.forms[key]);
      }
    }

    if (
      'pageIndex' in data &&
      data.pageIndex !== '' &&
      data.pageIndex !== undefined
    ) {
      param = param.append('page', data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined) {
      param = param.append('limit', data.limit);
    }

    return this.http.get(`${environment.apiUrl}/leaves/leave_rel_strgy`, {
      params: param,
    });
  }
  getLevel(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/leaves/level`,
    );
  }

   addLvsLevStr(data: FormData): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/leaves/add_lv_str_action`,
      data
    );
  }

  editRelStgy(relID:any): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/leaves/edit_lv_str/` + relID
    );
  }

  deleteRelStgy(relID:any): Observable<any> {
    return this.http.post(`${environment.apiUrl}/leaves/delete_lv_str`, {
      rel_id: relID,
    });
  }

  //Added by shahid
  downloadStrategyTemplate(): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/leaves/download_leave_strategy_template_file`
    );
  }

  leaveApproDetails(leaveID:any): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/leaves/leave_appro_details/` + leaveID
    );
  }

}
